export function readObservedPricing(item) {
  const meta = item?.item_meta && typeof item.item_meta === 'object' ? item.item_meta : {}
  const pricing = meta.pricing && typeof meta.pricing === 'object' ? meta.pricing : meta
  const currency = String(pricing.observed_currency || pricing.currency || 'JPY').toUpperCase()
  const amount = Number(
    currency === 'EUR'
      ? (pricing.observed_price_eur ?? pricing.converted_price_eur ?? item?.price ?? 0)
      : (pricing.observed_price_jpy
        ?? pricing.observedPriceJpy
        ?? pricing.detected_price
        ?? 0),
  )
  if (!Number.isFinite(amount) || amount <= 0) return null
  const status = String(pricing.conversion_status || meta.conversion_status || '')
  const convertedRaw = Number(pricing.converted_price_eur)
  const convertedEur = status === 'pending' || !(convertedRaw > 0) ? null : convertedRaw
  return {
    amount,
    currency,
    taxIncluded: pricing.tax_included ?? null,
    exchangeRate: Number(pricing.exchange_rate || 0) || null,
    convertedEur,
    exchangeRateDate: String(pricing.exchange_rate_date || ''),
    conversionStatus: status || (convertedEur ? 'live' : 'pending'),
    conversionStale: Boolean(pricing.conversion_stale || meta.conversion_stale),
  }
}

export function observedJpyTotal(items = []) {
  return items.reduce((total, item) => {
    const observed = readObservedPricing(item)
    if (!observed || observed.currency !== 'JPY') return total
    return total + observed.amount * (Number.parseInt(item?.quantity, 10) || 1)
  }, 0)
}

export function readEditPricing(item) {
  const meta = item?.item_meta && typeof item.item_meta === 'object' ? item.item_meta : {}
  const nested = meta.price && typeof meta.price === 'object' ? meta.price : {}
  const raw = String(meta.observed_currency || nested.currency || nested.observed_currency || '').toUpperCase()
  if (raw === 'JPY') {
    const observed = Number(meta.observed_price_jpy)
    const converted = Number(meta.converted_price_eur)
    return {
      currency: 'JPY',
      amount: Number.isFinite(observed) && observed > 0 ? observed : '',
      convertedEur: Number.isFinite(converted) && converted > 0 ? converted : null,
      exchangeRate: Number(meta.exchange_rate) > 0 ? Number(meta.exchange_rate) : null,
      exchangeRateDate: String(meta.exchange_rate_date || ''),
      conversionStatus: String(meta.conversion_status || ''),
    }
  }
  const observedEur = Number(meta.observed_price_eur)
  const fallback = Number(item?.price)
  const amount = Number.isFinite(observedEur) && observedEur > 0
    ? observedEur
    : (Number.isFinite(fallback) ? fallback : 0)
  return {
    currency: 'EUR',
    amount,
    convertedEur: amount,
    exchangeRate: null,
    exchangeRateDate: '',
    conversionStatus: raw === 'EUR' ? String(meta.conversion_status || 'direct') : 'direct',
  }
}

export function formatJpy(value) {
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0)
}
